export enum FileBlockStatusEnum {
  unstarted = 1,
  processing = 2,
  successed = 3,
  completedWithErrors = 4,
  failed = 5,
}
